export enum EVictimsSituation {
  Wounded = 'Wounded',
  Dead = 'Dead'
}
